import React from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../../../components/FontAwesomeIcons";
import {Base64} from "../../../../../../helpers/Base64";
import AppConfig from "../../../../../../config/AppConfig";
import AuthAPI from "../../../../../../api/AuthAPI";

/**
 * Apre la consulenza con lo stesso passaggio al browser usato dai meeting lato cliente.
 * @param {Object} props
 * @param {String} props.url Link opzionale ricevuto dal server.
 * @return {React.ReactElement|null} Pulsante, oppure null per server senza link meeting.
 */
export function OnlineMeetingButton(props) {
    if (typeof props.url !== 'string' || !/^https?:\/\//i.test(props.url.trim())) return null;

    const meetingRoute = props.url.replaceAll(AppConfig.webServerUrl, '');
    const autologinUrl = `${AppConfig.webServerUrl}/api/dashboard/autologin/${AuthAPI.getUserAccessToken()}?redirect=${Base64.encode(meetingRoute)}`;


    return (
        <a className={"btn btn-success btn-block mb-3"} target={"_blank"} rel={"noopener noreferrer"}
           href={`https://proinn.web.app/bookizon/redirect.html?url=${Base64.encode(autologinUrl)}`}>
            <FaSolidIcon name={"video-camera"}/> Accedi alla video chat
        </a>
    );
}

OnlineMeetingButton.propTypes = {
    url: PropTypes.string
};
